/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { repeatMobileOrderComboItemSchema } from "./repeatMobileOrderComboItemSchema.ts";

export const repeatMobileOrderComboGroupSchema = z.object({
	id: z.uuid(),
	item: repeatMobileOrderComboItemSchema,
});
